import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const Contact = ({ showTitle = true }) => {

  const { t } = useTranslation();

  return (
    <div id="contactStrate" className={"strate footer2"}>
      {showTitle && <h1 dangerouslySetInnerHTML={{ __html: t("contact_contact") }} />}

      <div id={"contact_wrapper"}>
        <p dangerouslySetInnerHTML={{ __html: t("contact_besoin_d_en_savoir_plus") }} />
        <div className={"contact_block"} id={"contact_block_tel"}>
          <div className={"icon"} />
          <div className={"title"} dangerouslySetInnerHTML={{ __html: t("contact_par_telephone") }} />
          <div className={"link"} dangerouslySetInnerHTML={{ __html: t("contact_telephone_number") }} />
          <div className={"mention"} dangerouslySetInnerHTML={{ __html: t("contact_appel_non_surtaxe") }} />
        </div>
        <div className={"contact_block"} id={"contact_block_mail"}>
          <div className={"icon"} />
          <div className={"title"} dangerouslySetInnerHTML={{ __html: t("contact_par_email") }} />
          <div className={"link"}><a href={"mailto:rendezvousbarriere@tlcrewards.com?subject=Op%C3%A9ration%20Les%20Rendez-Vous%20Barri%C3%A8re%20%2F%20Vos%20nom%20et%20pr%C3%A9nom"}>rendezvousbarriere@tlcrewards.com</a></div>
          <div className={"mention"} dangerouslySetInnerHTML={{ __html: t("contact_objet") }} />
        </div>
      </div>
    </div>
  );
};

export default Contact;
